/**
 * Buyhatke: Price History & Tracker, Spend Lens
 *
 * Exposes a large static WAR group to every origin with no `use_dynamic_url`, including
 * `src/assets/img/ext_active.png` and `ext_inactive.png` (the toolbar state icons) and
 * `src/ui/css/app.css`. It also scopes hundreds more resources to specific shopping
 * sites, but the broad ones alone make it detectable anywhere.
 *
 * Manifest verified against version 5.1.152.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ojplmecpdpgccookcobabopnaifgidhf';

export const buyhatke: ExtensionDefinition = {
  id: ID,
  name: 'Buyhatke: Price History & Tracker, Spend Lens',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Broad static WAR (state icons, app.css) on every origin, plus hundreds of ' +
    'site-scoped resources. The broad images are conclusive and CORS-free.',
  signals: [
    {
      id: 'war-ext-active-image',
      kind: 'web-accessible-resource',
      description:
        'Load src/assets/img/ext_active.png via <img> — a toolbar-state icon exposed to ' +
        'every origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'src/assets/img/ext_active.png'),
    },
    {
      id: 'war-app-css',
      kind: 'web-accessible-resource',
      description: 'Fetch src/ui/css/app.css — the injected UI stylesheet, a second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'src/ui/css/app.css'),
    },
  ],
};
